import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.231 4.09a2.431 2.431 0 1 1-4.862 0 2.431 2.431 0 0 1 4.862 0ZM19.631 4.09a2.431 2.431 0 1 1-4.863 0 2.431 2.431 0 0 1 4.863 0Z"
    />
    <path
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.984 19.684v-2.78a3.016 3.016 0 1 1 6.032 0v2.78"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.797 10.276a5.2 5.2 0 0 0-5.015-3.755C3.908 6.531 1.6 8.903 1.6 11.777c0 1.334.609 2.594 1.653 3.424m8.95-4.925a5.2 5.2 0 0 1 5.015-3.755c2.874.01 5.182 2.382 5.182 5.256a4.37 4.37 0 0 1-1.653 3.424L12 22.147l-6.4-5.082"
    />
    <path
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.812 12.076a1.812 1.812 0 1 1-3.624 0 1.812 1.812 0 0 1 3.624 0Z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const FamilyIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
